/* eslint-disable react/require-default-props */
import React from 'react';
import {Text} from 'react-native';
import {View} from 'react-native';

import {Reports} from '/constant/TestIDs';
import testProperties from '/util/testing/testProperties';

import KeyboardFocusable from '../ExtKeyboard/KeyboardFocusable';
import Icon from '../Icon';

import styles from './FilterButton.style';

interface FilterButtonProps {
  onPress: () => void;
  text: string;
  testID: string;
  active: boolean;
  hideArrow: boolean;
  disabled: boolean;
  style: any;
  allowFontScaling?: boolean;
  maxFontSizeMultiplier?: number;
}
const FilterButton: React.FC<FilterButtonProps> = ({
  onPress = null,
  text = '',
  testID = '',
  active = false,
  hideArrow = false,
  disabled = false,
  style = {},
  allowFontScaling = false,
  maxFontSizeMultiplier = undefined,
}) => {
  const accessibilityLabel = text;
  const buttonBaseStyle = active ? styles.selectedButton : styles.button;
  const keyboardFocusableStyle = disabled
    ? [buttonBaseStyle, styles.disabled, style]
    : Object.keys(style).length > 0
    ? [buttonBaseStyle, style]
    : buttonBaseStyle;

  return (
    <KeyboardFocusable
      {...testProperties(testID, true)}
      testID={testID}
      accessible={true}
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel}
      onPress={onPress}
      disabled={disabled}
      style={keyboardFocusableStyle}>
      <View style={styles.buttonStyle}>
        <Text
          allowFontScaling={allowFontScaling}
          maxFontSizeMultiplier={maxFontSizeMultiplier}
          style={styles.buttonText}
          {...testProperties(Reports.reportFilterButtonLabel, true)}>
          {text}
        </Text>
        {!hideArrow && <Icon name="chevron-down" style={styles.arrowIcon} />}
      </View>
    </KeyboardFocusable>
  );
};

export default FilterButton;
